module.exports = __webpack_public_path__ + "img/venue-front.00f0a276.jpg";